import React from "react";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";

const ConfirmationBlock = observer(({ block }) => {
  const resolved = Boolean(block.resolution);

  return (
    <div className={`copilotConfirm ${resolved ? "resolved" : ""}`}>
      <div className="copilotConfirm__prompt">
        <i className="material-icons-outlined">help_outline</i>
        <span>{block.prompt}</span>
      </div>
      {!resolved ? (
        <div className="copilotConfirm__actions">
          <button
            type="button"
            className="copilotConfirm__btn primary"
            disabled={copilotStore.streaming}
            onClick={() => copilotStore.respondConfirmation(block.id, true)}
          >
            {block.confirmLabel || "Confirm"}
          </button>
          <button
            type="button"
            className="copilotConfirm__btn"
            disabled={copilotStore.streaming}
            onClick={() => copilotStore.respondConfirmation(block.id, false)}
          >
            {block.cancelLabel || "Cancel"}
          </button>
        </div>
      ) : (
        <div className="copilotConfirm__resolution">
          <i className="material-icons-outlined">
            {block.resolution === "confirmed" ? "check_circle" : "cancel"}
          </i>
          <span>
            {block.resolution === "confirmed"
              ? block.confirmLabel || "Confirmed"
              : block.cancelLabel || "Cancelled"}
          </span>
        </div>
      )}
    </div>
  );
});

export default ConfirmationBlock;
